'use client';

import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import useClosedSearchEvent from 'hooks/useClosedSearchEvent';
import { getDateSearch, updateUrlQueryParam } from 'utils/misc';
import { ClosedSearchSubHeader } from 'components/ClosedSearchSubHeader';
import SearchEventList from 'components/SearchEventList/SearchEventList';
import {
  Container,
  SearchBodyContainer,
} from 'components/Container/Container.css';
import SearchContent from 'components/Shared/SearchContent/SearchContent';
import { defaultSearchTitle, urlParamsSearch } from 'constants/search';
import { listPredefinedDates } from 'constants/listPredefinedDates';
import { SearchEventResult } from 'searchEvent';
import { ParamsMapSearch, ParamsResult } from 'ParamsResult.d';
import { Location } from 'location';
import { InstantSearch } from 'react-instantsearch';
import searchClient from 'utils/algolia';
import { ALGOLIA_INDEX_NAME } from 'constants/algolia';
import { AlgoliaSearchEvents } from './AlgoliaSearchEvents/AlgoliaSearchEvents';

export type ClosedSearchEventTemplateProps = {
  params: ParamsResult;
  searchDataResult: SearchEventResult;
  isMobile: boolean;
  paramsMapSearch?: ParamsMapSearch;
  location: Location;
  slugs: string;
};

function ClosedSearchEventTemplate({
  searchDataResult,
  params,
  isMobile,
  paramsMapSearch,
  location,
  slugs,
}: ClosedSearchEventTemplateProps) {
  const title = params?.url_params?.component?.name
    || params?.search_params?.component_uuid?.toUpperCase() /** belo-horizonte-mg/hoje */
    || params?.url_params?.date?.name /** gastronomico/hoje */
    || defaultSearchTitle; /** empty */

  const isAlgoliaSearch = listPredefinedDates.some((option) => slugs?.includes(option.dateId));

  // TODO: REFACTOR AFTER THE PREDEFINED SEARCH IS 100% ALGOLIA
  const closedSearchEventStore = useClosedSearchEvent();
  if (!isAlgoliaSearch) closedSearchEventStore.hydrate(searchDataResult);
  useEffect(() => {
    if (!isAlgoliaSearch) closedSearchEventStore.setResults(searchDataResult);
  }, [searchDataResult, paramsMapSearch]);

  if (isAlgoliaSearch) {
    const textDate = slugs?.split('/').pop() || '';
    const date = getDateSearch(textDate);
    return (
      <InstantSearch searchClient={searchClient} indexName={ALGOLIA_INDEX_NAME} insights>
        <AlgoliaSearchEvents
          params={params}
          location={location}
          date={date}
          title={title}
        />
      </InstantSearch>
    );
  }

  if (paramsMapSearch) closedSearchEventStore.hydrateParams(paramsMapSearch);
  return (
    <div>
      <ClosedSearchSubHeader params={params} title={title} />
      <div className={SearchBodyContainer}>
        <div className={Container}>
          <SearchContent
            pageTypeText="eventos"
            searchResult={closedSearchEventStore?.searchDataResult}
            totalPages={closedSearchEventStore?.totalPages}
            isFetching={closedSearchEventStore?.isFetching}
            isMobile={isMobile}
            onChangePage={(page: string | number) => {
              if (!isMobile) {
                updateUrlQueryParam({ param: urlParamsSearch.page, value: String(page) });
              }

              closedSearchEventStore.fetchPaginationData({
                query: window?.location?.search,
                isMobile,
                page,
                onSuccess: () => window?.scrollTo({ top: 0, left: 0 }),
              });
              return +page;
            }}
          >
            <SearchEventList events={closedSearchEventStore?.searchDataResult?.data} serviceParams={params} isMobile={isMobile} />
          </SearchContent>
        </div>
      </div>
    </div>
  );
}

export default observer(ClosedSearchEventTemplate);
